import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const productTypeModURL = "api/v1/products-app/type";
//obtaining the paginated data
export const getProductType = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${productTypeModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllProductType = () => axiosInstance.get(`${productTypeModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageProductType = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${productTypeModURL}/list?offset=${(number - 1) * rowsPerPage}&limit=${rowsPerPage}&ordering=-id`);

//creating function
export const createProductType = (body) => axiosInstance.post(`${productTypeModURL}/create`, body);
//updating function
export const updateProductType = (id, body) => axiosInstance.patch(`${productTypeModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${productTypeModURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`);

// checking the redundant data
export const checkRedundantDataProductTypeName = (e, cancelToken) =>
  axiosInstance.get(`${productTypeModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
